// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"NB-z","smallCardRow":"OB-z","largeCardRow":"PB-z","productSearchRow":"QB-z","curatedRow":"RB-z"};